import {Component, OnInit} from '@angular/core';
import {PreloaderService} from "../../../services/preloader/preloader.service";
import {MyGreenCountry} from "../../../services/mygreencountry/my-greencountry";
import {FeedbackForm} from "../../../types/interfaces";

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent implements OnInit {
    openFeedbackInput: boolean = false;
    mark: number | undefined = undefined;
    role: 'student' | 'parent' | undefined = undefined;
    feedback: string | null = ''
    feedbackForm: FeedbackForm;
    requestSuccess: boolean = false;
    showResponseModal: boolean = false;
    responseMark: string | null = null
    responseMessage:string | null = null;

    constructor(private preloaderService: PreloaderService, public myGcService: MyGreenCountry,) {
    }

    ngOnInit() {
    }

    choseEmoji(event: any, emojiNumber: number): void {
        let clickedEmoji = event.target;
        this.unchooseEmoji();

        clickedEmoji.parentElement.classList.add('active');
        this.mark = emojiNumber;

        this.openFeedbackInput = true;
        this.requestSuccess = false;
    }

    choseRole(event: any, selectedRole: 'student' | 'parent'): void {
        let clickedEmoji = event.target;
        let allEmojis = document.querySelectorAll('.btn-role');

        allEmojis.forEach((emoji: any) => {
            emoji.classList.remove('active');
        });

        clickedEmoji.classList.add('active');

        this.role = selectedRole;
        this.openFeedbackInput = true;
    }

    async submit() {
        if (this.role && this.mark && this.feedback) {
            this.feedbackForm = {
                role: this.role,
                mark: this.mark,
                feedback: this.feedback
            }

            await this.preloaderService.showLoading('Зачекайте, будь ласка');
            this.myGcService.sendFeedback(this.feedbackForm)
                .subscribe({
                    next: (response) => {
                        if (response.success) {
                            this.requestSuccess = true;
                            this.showResponseModal = true;
                            this.responseMark = response.responseMark;
                            this.responseMessage = response.message
                            this.setToDefault();
                        }

                    },

                    error: (error) => {
                        console.log('error', error)

                    },

                    complete: () => {

                        this.preloaderService.hideLoading();

                    }

                })

        }
    }

    unchooseEmoji(): void {
        let allEmojis = document.querySelectorAll('.emoji');

        allEmojis.forEach((emoji: any) => {
            emoji.classList.remove('active');
        });

    }

    close() {
        this.setToDefault();
    }

    setToDefault(){
        this.openFeedbackInput = false;
        this.mark =undefined;
        this.role = undefined;
        this.feedback = null;
        this.unchooseEmoji()
    }
}
